import type { ParallaxTheme } from '~/sanity/types';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export const applyAnimation = (
  animation: ParallaxTheme['animation'],
  parallaxWrapper: globalThis.Ref<HTMLElement | null>
) => {
  if (!parallaxWrapper.value) return;

  if (animation && animation !== 'none') {
    gsap.set(parallaxWrapper.value, { opacity: 0 }); // Ensure initial state // Ensure no previous animation is running
  }

  ScrollTrigger.create({
    trigger: parallaxWrapper.value,
    start: 'top 80%', // Adjust trigger point
    toggleActions: 'play reverse play reverse',
    scrub: true,
    onEnter: () => {
      switch (animation) {
        case 'topToButton':
          gsap.fromTo(
            parallaxWrapper.value,
            { y: -100, opacity: 0 },
            { y: 0, opacity: 1, duration: 1.5 }
          );
          break;
        case 'leftToRight':
          gsap.fromTo(
            parallaxWrapper.value,
            { x: -200, opacity: 0 },
            { x: 0, opacity: 1, duration: 1.5 }
          );
          break;
        case 'rightToLeft':
          gsap.fromTo(
            parallaxWrapper.value,
            { x: 200, opacity: 0 },
            { x: 0, opacity: 1, duration: 1.5 }
          );
          break;
        case 'fadeIn':
          gsap.fromTo(parallaxWrapper.value, { opacity: 0 }, { opacity: 1, duration: 1.5 });
          break;
        default:
          break;
      }
    },
  });
};

/* Handle Mouse enter effect for any card by translating up */
export const translateUp = (event: MouseEvent, yValue: number = -4, duration: number = 0.3) => {
  const element = event.currentTarget as HTMLElement; // Cast to HTMLElement
  gsap.timeline().to(element, { y: yValue, duration: duration, ease: 'power2.out' });
};

/* Handle Mouse Leave effect for any card by translating down */
export const translateDown = (event: MouseEvent, yValue: number = 0, duration: number = 0.3) => {
  const element = event.currentTarget as HTMLElement; // Cast to HTMLElement
  gsap.timeline().to(element, { y: yValue, duration: duration, ease: 'power2.out' });
};
